import { makeEnvironmentProviders } from '@angular/core';
import { ClaimsAuthzService } from '@mri-platform/resource-authz';
import { EntityClaimsAuthzService, provideEntity } from '@mri-platform/shared/entity';
import { EntityDataModuleConfig, provideEntityData, withEffects } from '@ngrx/data';
import { ClearEntityCacheProvider } from './clear-entity-cache';
import { DataServiceConfigProvider } from './data-service-config.provider';

export function provideAppNgrxIntegration(config?: EntityDataModuleConfig) {
  return makeEnvironmentProviders([
    provideEntityData(config ?? {}, withEffects()),
    provideEntity(),
    DataServiceConfigProvider,
    ClearEntityCacheProvider,
    { provide: ClaimsAuthzService, useExisting: EntityClaimsAuthzService }
  ]);
}
